module.exports = __webpack_public_path__ + "img/link-icon.1f80ebdf.svg";